var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
var getContainer = function (selector) {
    var maybeOverlay = document.querySelector(selector);
    return maybeOverlay || document.body;
};
export var Tooltip = function (_a) {
    var trigger = _a.trigger, _b = _a.parent, parent = _b === void 0 ? '[class*="Overlay_container__"]' : _b, props = __rest(_a, ["trigger", "parent"]);
    var _c = useState(), target = _c[0], acceptTarget = _c[1];
    var triggerEl = useMemo(function () {
        return React.isValidElement(trigger) &&
            React.cloneElement(trigger, {
                ref: acceptTarget,
            });
    }, [trigger]);
    var _d = useState(), container = _d[0], setContainer = _d[1];
    useEffect(function () { return setContainer(getContainer(parent)); }, [parent]);
    return (React.createElement(Fragment, null,
        triggerEl,
        target && React.createElement(UncontrolledTooltip, __assign({ container: container }, props, { target: target }))));
};
//# sourceMappingURL=Tooltip.js.map